module.exports = __webpack_public_path__ + "img/ie_logo_menu_test.d61e5268.png";